import { gql } from '@apollo/client'

export const OPERATION_COUNT_EQUIPMENTS = gql`
  query GetMonitoringEquipmentCounts($sf_ids: [String]) {
    counting: monitoringCounting(sf_ids: $sf_ids) {
      access_point_ok: accesspoint_ok
      access_point_unreachable: accesspoint_unreachable
      switch_ok
      switch_unreachable
      esl_ok
      esl_unreachable
      chromecast_ok
      chromecast_unreachable
      tv_ok
      tv_unreachable
      firewall_ok
      firewall_unreachable
      cctv_camera_ok
      cctv_camera_unreachable
      cctv_server_ok
      cctv_server_unreachable
      inverter_ok: pcd_ok
      inverter_unreachable: pcd_unreachable
    }
  }
`

export const OPERATION_FIND_APS = gql`
  query GetFindAPS($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      access_points {
        site {
          id
          sf_id
          name
          account_parent {
            sf_id
            name
          }
        }
        uuid
        mac
        label
        model
        manufacturer
        ip_address
        available_level
        is_reachable
        is_snmp_reachable
        building_name
        floor_name
        serial
        channel_a
        channel_g
        cpu_usage
        memory_usage
        system_uptime
        ssid_names
        ssids {
          name
          has_2_4ghz
          has_5ghz
        }
        connected_stations
      }
    }
  }
`

export const OPERATION_FIND_CHROMECASTS = gql`
  query GetFindChromecast($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      chromecasts {
        site {
          id
          sf_id
          name
        }
        uuid
        label
        available_level
        building_name
        floor_name
        ip_address
        manufacturer
        model
        room
        mac
        ip_address
      }
    }
  }
`

export const OPERATION_FIND_ESLS = gql`
  query GetFindESL($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      access_points {
        site {
          id
          sf_id
        }
        uuid
        available_level
      }
      esls {
        site {
          id
          sf_id
          name
        }
        uuid
        label
        available_level
        building_name
        floor_name
        ip_address
        manufacturer
        model
        mac
        ip_address
      }
    }
  }
`

export const OPERATION_FIND_SWITCHES = gql`
  query GetFindSwitches($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      switches {
        site {
          id
          sf_id
          name
          account_parent {
            sf_id
            name
          }
        }
        uuid
        label
        mac
        model
        ip_address
        manufacturer
        available_level
        is_reachable
        is_snmp_reachable
        building_name
        floor_name
        serial
        hostname
        cpu_usage
        memory_usage
        system_uptime
        poe {
          measured
          reserved
          max
        }
      }
    }
  }
`

export const OPERATION_CHILDREN_ACCOUNTS = gql`
 query GetChildrenAccounts($sf_id: String!) {
     accounts: childrenAccount(sf_id: $sf_id) {
         sf_id,
         name
     }
 }   
`

export const OPERATION_FIND_INVERTERS = gql`
  query GetFindInverters($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      inverters {
        site {
          id
          sf_id
          name
          account_parent {
            sf_id
            name
          }
        }
        uuid
        label
        mac
        model
        ip_address
        manufacturer
        available_level
        building_name
        floor_name
        battery_charge
        battery_time_remaining
        total_load
        battery_status
        battery_replace_date
      }
    }
  }
`

export const OPERATION_FIND_TVS = gql`
  query GetFindTVS($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      tvs {
        site {
          id
          sf_id
          name
        }
        uuid
        label
        mac
        ip_address
        available_level
        building_name
        floor_name
        manufacturer
        model
        room
      }
    }
  }
`

export const OPERATION_FIND_FIREWALLS = gql`
  query GetFindFirewalls($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      firewalls {
        site {
          id
          sf_id
          name
          account_parent {
            sf_id
            name
          }
        }
        uuid
        label
        mac
        ip_address
        available_level
        building_name
        floor_name
        serial
        is_reachable
        is_snmp_reachable
        manufacturer
        model
        type
        system_name
        cpu_usage
        memory_usage
        firmware_version
        total_tunnels
        tunnels_up
        system_uptime
        cluster_stats {
          system_mode
          auto_sync
          load_balancing_scheduler
          group_name
          nodes {
            name
            serial_number
            cpu_usage
            memory_usage
            network_usage
            session_count
            byte_count
            hostname
            sync_status
          }
        }
        tunnels_stats {
          phase1_name
          phase2_name
          remote_gateway_ip
          local_gateway_ip
          rx_bytes
          tx_bytes
          up_status
        }
      }
    }
  }
`

export const OPERATION_FIND_CCTV_CAMERAS = gql`
  query GetFindCCTVCameras($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      cctv_cameras {
        site {
          id
          sf_id
          name
          account_parent {
            sf_id
            name
          }
        }
        uuid
        label
        mac
        ip_address
        available_level
        is_snmp_reachable
        building_name
        floor_name
        manufacturer
        model
        system_uptime
        cpu_usage
        memory_usage
        video_codec
        video_resolution {
          width
          height
        }
        firmware_version
        hardware_type
      }
    }
  }
`

export const OPERATION_FIND_CCTV_SERVERS = gql`
  query GetFindCCTVServers($sf_ids: [String!]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      cctv_servers {
        site {
          id
          sf_id
          name
          account_parent {
            sf_id
            name
          }
        }
        uuid
        label
        mac
        ip_address
        available_level
        building_name
        floor_name
        manufacturer
        model
        disk_usage
        disk_1_usage
        disk_2_usage
        disks_info
        cloud_connection {
          status
          error_code
        }
      }
    }
  }
`

export const OPERATION_FIND_SITE = gql`
  query GetSite($sf_id: String!) {
    site: findSite(sf_id: $sf_id) {
      ... on Site {
        account_parent {
          sf_id
          name
        }
        sf_id
        name
        id
        equipment {
          available_level
        }
        devices(extended: true) {
          uuid
          parent
          children {
            uuid
            serial
            mac
            model {
              name
              type
              oid
              manufacturer
            }
            position {
              x
              y
              map {
                uuid
              }
            }
            label
            status
          }
          serial
          mac
          model {
            name
            type
            oid
            manufacturer
          }
          position {
            x
            y
            map {
              uuid
            }
          }
          label
          status
        }
        surface_areas {
          uuid
          name
          maps {
            uuid
            name
            level  
          }
        }
      }
    }
  }
`

export const OPERATION_DEVICES_BY_FLOOR = gql`
  query GetDevicesByFloorId($id: String!) {
    devices: devicesByMap(uuid: $id) {
      ... on DevicePosition {
        x
        y
        device {
          uuid
          serial
          model {
            type
            oid
            name
          }
          position {
            x
            y
          }
          label
          status
        }
      }
    }
  }
`

export const OPERATION_IMAGE = gql`
  query GetDownloadMapImage($id: String!) {
    image: downloadMapImage(uuid: $id) {
      ... on Image {
        dataURL
        width
        height
      }
    }
  }
`

export const MONITORING_DEVICES = gql`
  query GetDevicesBySites($sf_ids: [String]) {
    equipments: monitoringDevices(sf_ids: $sf_ids) {
      access_points {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        mac
        label
        model
        manufacturer
        ip_address  
        is_reachable
        building_name
        floor_name
        channel_a
        channel_g
        ssid_names
        ssids {
          name
          has_2_4ghz
          has_5ghz
        }
        connected_stations
      }
      chromecasts {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        label
        is_reachable
        building_name
        floor_name
        ip_address
        manufacturer
        model
        room
        mac
        ip_address
      }
      esls {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        label
        is_reachable
        building_name
        floor_name
        ip_address
        manufacturer
        model
        mac
        ip_address
      }
      switches {
        available_level
        site {
          id
          sf_id 
          name
        }
        uuid
        label
        mac
        model
        ip_address
        manufacturer
        is_reachable
        building_name
        floor_name
      }
      wiboxes {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        label
        mac
        model
        ip_address
        manufacturer
        is_reachable
        building_name
        floor_name
      }
      tvs {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        label
        mac
        ip_address
        is_reachable
        building_name
        floor_name
        manufacturer
        model
      }
      cctv_cameras {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        label
        mac
        ip_address
        is_reachable
        building_name
        floor_name
        manufacturer
        model
        video_codec
        video_resolution {
            width
            height
        }
        firmware_version
        hardware_type
      }
      cctv_servers {
        site {
            id
            sf_id
            name
        }
        uuid
        label
        mac
        ip_address
        available_level
        building_name
        floor_name
        manufacturer
        model
        disk_usage
        disk_1_usage
        disk_2_usage
        disks_info
        cloud_connection {
            status
            error_code
        }
        connected_cameras {
            mac
            label
            connected
            is_reachable
            available_level
        }
      }
      firewalls {
        site {
          id
          sf_id
          name
        }
        uuid
        label
        mac
        ip_address
        available_level
        building_name
        floor_name
        serial
        manufacturer
        model
        type
        total_tunnels
        tunnels_up
        system_uptime
      }
      inverters {
        available_level
        site {
          id
          sf_id
          name
        }
        uuid
        label
        mac
        model
        ip_address
        manufacturer
        is_reachable
        building_name
        floor_name
        battery_charge
        battery_time_remaining
        total_load
        battery_status
        battery_replace_date
      }
    }
  }
`

export const FIND_AP_PARENT = gql`
  query GetAPParentData($mac: String!) {
    ap: findAPByMac(mac: $mac) {
      parent_label
      parent_mac
      parent_port
      parent_status
      parent_is_reachable
    }
  }
`

export const OPEREATION_FIND_DEVICE = gql `
  query FindDevice($uuid: ID!) {
    device: findDevice(uuid: $uuid) {
      label
      position {
        map {
          uuid
          surface_area {
            uuid
          }
        }
      }
    }
  }
`

export const AP_CONNECTED_STATIONS_GRAPH = gql`
  query GraphConnectedStationsByMacs($sf_id: ID!, $macs: [String]!, $timeRange: CCTVTimeRangeInput) {
    aps: graphConnectedStationsByMacs(sf_id: $sf_id, macs: $macs, timeRange: $timeRange) {
      mac
      stamp
      connected_stations
    }
  }
`

export const AP_REACHABILITY_GRAPH = gql`
  query FindAPReachability($mac: String!, $timeRange: CCTVTimeRangeInput) {
    apHistory: findAPHistoryByMac(mac: $mac, timeRange: $timeRange) {
      timestamps
      status
    }
  }
`

export const SWITCH_REACHABILITY_GRAPH = gql`
  query FindSwitchReachability($mac: String!, $timeRange: CCTVTimeRangeInput) {
    switchHistory: findSwitchHistoryByMac(mac: $mac, timeRange: $timeRange) {
      timestamps
      status
    }
  }
`

export const CCTV_CAMERA_REACHABILITY_GRAPH = gql`
  query FindCCTVCameraReachability($mac: String!, $timeRange: CCTVTimeRangeInput) {
    cctvCameraHistory: findCCTVCameraHistoryByMac(mac: $mac, timeRange: $timeRange) {
      timestamps
      status
    }
  }
`

export const CCTV_SERVER_CONNECTED_CAMERAS = gql`
  query FindCCTVServerConnectedCameras($mac: String!, $site_id: ID!) {
    connectedCameras: findCCTVServerConnectedCameras(mac: $mac, site_id: $site_id) {
      mac
      label
      ip_address
      connected
      is_reachable
      available_level
    }
  }
`

export const CCTV_SERVER_DISK_GRAPH = gql`
  query FindCCTVServerGraphData($mac: String!, $timeRange: CCTVTimeRangeInput!) {
    cctvServerGraph: findCCTVServerGraphData(mac: $mac, timeRange: $timeRange) {
      timestamps
      disk_1_usage
      disk_2_usage
    }
  }
`

export default OPERATION_FIND_APS
